import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import OrderActions from "./OrderActions";
import { styled } from "@mui/material/styles";
import { CmsMasterData } from "types/models/cmsMaster/CmsMasterApp";

const commonCellStyle = {
  fontSize: 14,
  width: 200,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};

const MultiLineText = styled('div')(() => ({
  whiteSpace: 'normal',
  lineHeight: 1.4,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
}));

interface TableItemProps {
  cms: CmsMasterData;
}

const TableItem: React.FC<TableItemProps> = ({ cms }) => {
  const fields = [
    cms.PageTitle,
    cms.MetaTitle,
    cms.MetaKeyword,
    cms.MetaDesc,
    cms.HeaderName1,
    cms.HeaderName2,
  ];

  return (
    <TableRow className="item-hover">
      <TableCell align="left" sx={commonCellStyle}>
        <OrderActions data={cms} />
      </TableCell>

      {fields.map((field, index) => (
        <TableCell key={index} align="left" sx={commonCellStyle}>
          <MultiLineText dangerouslySetInnerHTML={{ __html: field }} />
        </TableCell>
      ))}
    </TableRow>
  );
};

export default TableItem;
